import commonState from 'top20common/distribution/store/state';

export default {
  ...commonState,
  loginForm: {
    email: null,
    password: null,
    isRemember: false
  },
  emailConfirmation: {
    errors: null,
    success: null
  },
  resetConfirmation: {
    errors: {},
    success: null,
    password: null
  },
  resetPasswordForm: {
    emailInputComponent: true,
    errors: null,
    loading: null
  },
  changePasswordForm: {
    password: null
  },
  changedPasswordConfirmation: {
    loading: null,
    error: null,
    detail: null,
    success: null
  },
  companiesOfInterestFormState: {
    companiesList: null,
    meta: {},
    loading: null
  },
  companiesOfInterestErrorState: null, // separate state to not lose focus on input when state changes.
  countSavedCompaniesOfInterestState: null,
  savedSearchesState: {
    loading: null,
    searches: null,
    errors: null
  },
  filtersState: {
    loading: false,
    error: null,
    all: null
  },
  referrerProfileState: null
};
